module.exports = __webpack_public_path__ + "static/img/z.ded8e1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/z.png
// module id = R4sx
// module chunks = 1